import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { ICON_FILE, ICON_FILE_DEFAULT } from '../constant'

export const CustomTdFormatFile = ({ val }) => {
  const dataFile = Object.values(ICON_FILE).find(
    (item) => item.label.toUpperCase() === val.replace('.', '').toUpperCase(),
  )
  const fomatDataFile = Object.keys(dataFile).length
    ? dataFile
    : ICON_FILE_DEFAULT

  return (
    <div className="dFlex gap1">
      <Icon
        className={fomatDataFile.className}
        style={{ fontSize: 14, color: fomatDataFile.color }}
      />
      <Element elementName="p" style={{ textTransform: 'uppercase' }}>
        {fomatDataFile.label}
      </Element>
    </div>
  )
}
